import styled from 'styled-components';
import colors from '../../theme/search/colors';

const Wrapper = styled.div`
  .checkbox-container {
    margin-bottom: 14px;
  }
  .label--checkbox {
    position: relative;
    cursor: pointer;
    font-size: 15px;
    line-height: 18px;
    color: #4a4a4a;
    display: flex;
    font-family: 'Roboto Condensed';

    > div {
      width: 220px;
    }
  }

  .checkbox {
    position: relative;
    margin: 0 28px 0 0;
    cursor: pointer;
    -webkit-appearance: none;
    -moz-appearance: none;
    -o-appearance: none;
    appearance: none;
    outline: none;
    display: inline-block;
  }
  .checkbox:before {
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
    content: '';
    position: absolute;
    left: 0;
    z-index: 1;
    width: 18px;
    height: 18px;
    border: 1px solid ${colors.checkbox};
    background: transparent !important;
  }
  .checkbox:checked:before {
    -webkit-transform: rotate(-50deg);
    -moz-transform: rotate(-50deg);
    -ms-transform: rotate(-50deg);
    -o-transform: rotate(-50deg);
    transform: rotate(-50deg);
    height: 8px;
    width: 13px;
    margin-left: 3px;
    margin-top: 4px;
    border: 2px solid ${colors.checkbox};
    border-color: #ffffff;
    border-top-style: none;
    border-right-style: none;
  }
  .checkbox:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 19px;
    height: 19px;
    background: transparent;
    cursor: pointer;
  }

  .checkbox:checked:after {
    background: #9b9b9b;
  }
`;

export { Wrapper };



// WEBPACK FOOTER //
// ./src/components/Checkbox/style.js